/*jslint regexp: true */

/**
 * A reusable dropdown plugin for jQuery
 * Allows the user to choose from a list of options or type a custom option
 */
(function ($) {
   "use strict";

   var methods = {
      moveUp: function () {
         var jThis = $(this),
            data = jThis.data('c21list'),
            jList = data.jList,
            jSelected = jList.find('.dropdownOptionSelected'),
            jPrev;

         jSelected.removeClass('dropdownOptionSelected');

         if (jSelected.hasClass('dropdownHeader')) {
            jPrev = jList.find('.dropdownOptionViewport .dropdownOption:last');
         } else {
            jPrev = jSelected.prev();
            if (jPrev.length === 0) {
               if (jList.find('.dropdownHeader.dropdownOption').length !== 0) {
                  jPrev = jList.find('.dropdownOption:first');
               } else {
                  jPrev = jList.find('.dropdownOption:last');
               }
            }
         }

         jPrev.addClass('dropdownOptionSelected');

         if (!jPrev.hasClass('dropdownHeader')) {
            jThis.c21list("scrollToHighlighted");
         }
      },

      moveDown: function () {
         var jThis = $(this),
            data = jThis.data('c21list'),
            jList = data.jList,
            jSelected = jList.find('.dropdownOptionSelected'),
            jNext;

         jSelected.removeClass('dropdownOptionSelected');

         if (jSelected.hasClass('dropdownHeader')) {
            jNext = jList.find('.dropdownOptionViewport .dropdownOption:first');
         } else {
            jNext = jSelected.next();
            if (jNext.length === 0) {
               jNext = jList.find('.dropdownOption:first');
            }
         }

         jNext.addClass('dropdownOptionSelected');

         if (!jNext.hasClass('dropdownHeader')) {
            jThis.c21list("scrollToHighlighted");
         }
      },

      indexOf: function (strValue) {
      },

      getValue: function () {
         var jThis = $(this),
            data = jThis.data('c21list'),
            jOptionViewport = data.jOptionViewport,
            aValues,
            jSelected;

         if (data.options.multiSelect) {
            aValues = [];
            $.each(data.aCheckboxes, function (i, jCheckbox) {
               if (jCheckbox.prop("checked")) {
                  aValues.push(data.aOptions[i].val());
               }
            });

            // Return all checked boxes
            return aValues;
         } else {
            // Return the highlighted box
            jSelected = jOptionViewport.find('.dropdownOptionSelected');
            return jSelected.attr("value");
         }
      },

      getText: function () {
         var jThis = $(this),
            data = jThis.data('c21list'),
            jOptionViewport = data.jOptionViewport,
            aValues,
            jSelected;

         if (data.options.multiSelect) {
            aValues = [];
            $.each(data.aCheckboxes, function (i, jCheckbox) {
               if (jCheckbox.prop("checked")) {
                  aValues.push(data.getDisplay(data.aOptions[i]));
               }
            });

            // Return all checked boxes
            return aValues;
         } else {
            // Return the highlighted box
            jSelected = jOptionViewport.find('.dropdownOptionSelected');
            return data.getDisplay(jSelected);
         }
      },

      addOption: function (strText, strValue, strSelectedDisplay) {
         var jThis = $(this),
            data = jThis.data('c21list'),
            options = data.options,
            jOptionContainer = data.jOptionContainer,
            jNewOption = $("<div />", {
               "class": 'dropdownOption',
               text: options.translate(strText),
               value: strValue
            });

         jOptionContainer.append(jNewOption);
         jNewOption.disableSelection();

         if (jNewOption.index() % 2 === 1) {
            jNewOption.addClass('dropdownOptionOdd');
         }

         if (strSelectedDisplay) {
            jNewOption.attr("selectedDisplay", strSelectedDisplay);
         }

         if (options.multiSelect) {
            var jCheckbox = $('<input type="checkbox" />');
            jNewOption.prepend(jCheckbox);
            data.aCheckboxes.push(jCheckbox);
            data.oCheckboxes[strValue] = jCheckbox;

            jNewOption.on("click", function (e) {
               // Stop the checkbox from checking twice
               if (e.target.nodeName === 'INPUT') {
                  e.stopPropagation();
                  return;
               }

               jCheckbox.attr("checked", !jCheckbox.attr("checked"));
            });
         }

         data.aOptions.push(jNewOption);
      },

      removeHighlight: function () {
         var jThis = $(this),
            data = jThis.data('c21list'),
            jOptionViewport = data.jOptionViewport,
            jSelected = jOptionViewport.find('.dropdownOptionSelected');

         jSelected.removeClass("dropdownOptionSelected");
      },

      addOptionsList: function (o) {
         var jThis = $(this);

         $.each(o, function (i, o) {
            var strValue, strText;

            if (Array.isArray(o)) {
               strValue = o[0];
               strText = o[1];
            } else {
               strValue = o;
               strText = o;
            }

            jThis.c21list("addOption", strText, strValue);
         });
      },

      empty: function () {
         var jThis = $(this),
            data = jThis.data('c21list'),
            jOptionContainer = data.jOptionContainer;

         data.aOptions = [];
         data.aCheckboxes = [];
         data.oCheckboxes = {};
         jOptionContainer.empty();
      },

      scrollToHighlighted: function () {
         var jThis = $(this),
            data = jThis.data('c21list'),
            jOptionViewport = data.jOptionViewport,
            jSelected = jOptionViewport.find('.dropdownOptionSelected'),
            iContainerScroll = jOptionViewport.scrollTop(),
            iContainerHeight = jOptionViewport.height(),
            iContainerBottom = iContainerScroll + iContainerHeight,
            position = jSelected.position(),
            iOptionHeight = jSelected.outerHeight(),
            iOptionTop = position.top + iContainerScroll,
            iOptionBottom = iOptionTop + iOptionHeight;

         if (iOptionBottom > iContainerBottom) {
            jOptionViewport.scrollTop(iOptionBottom - iContainerHeight);
         }

         if (iOptionTop < iContainerScroll) {
            jOptionViewport.scrollTop(iOptionTop);
         }
      },

      setAllChecked: function (bChecked) {
         var jThis = $(this),
            data = jThis.data('c21list'),
            jOptions = $();

         if (!data.options.multiSelect) {
            return undefined;
         }

         $.each(data.aOptions, function (i, jOption) {
            data.aCheckboxes[i].prop("checked", bChecked);
         });
      },

      /**
       * Checks the checkboxes with the passed indexes
       * @param {Number|Array} i
       * @param {Boolean} bChecked
       */
      setCheckedIndexes: function (i, bChecked) {
         var jThis = $(this),
            data = jThis.data('c21list');

         if (!data.options.multiSelect) {
            return undefined;
         }

         if (typeof i === "number") {
            data.aCheckboxes[i].prop("checked", bChecked);
         } else {
            $.each(i, function (j, n) {
               data.aCheckboxes[n].prop("checked", bChecked);
            });
         }
      },

      /**
       * Checks the checkbox with the passed values
       * @param {String|Array} i
       * @param {Boolean} bChecked
       */
      setChecked: function (i, bChecked) {
         var jThis = $(this),
            data = jThis.data('c21list');

         if (!data.options.multiSelect) {
            return undefined;
         }

         if (typeof i === "string") {
            data.oCheckboxes[i].prop("checked", bChecked);
         } else {
            $.each(i, function (j, n) {
               data.oCheckboxes[n].prop("checked", bChecked);
            });
         }
      },

      /**
       * Create the dropdown
       * Required options:
       *   baseName - The base name from which to create the inputs. Ex: "bedrooms" would create "bedroomsFrom" and "bedroomsTo"
       * Optional options: 
       *   dropdownClass - An additional class for the dropdown
       */
      init: function (options) {
         return this.each(function () {
            var jThis = $(this),
               data = jThis.data('c21list');

            // If the plugin hasn't been initialized yet
            if (!data) {
               var jList = $('<div />', {
                     html: [
                        '<div class="dropdownOptionViewport">',
                        '<div class="dropdownOptionContainer"></div>',
                        '</div>'
                     ].join(''),
                     "class": (options.standAlone === false) ? 'dropdownBox' : 'dropdownBox standAlone'
                  }),
                  jOptionViewport = jList.find('.dropdownOptionViewport'),
                  jOptionContainer = jList.find('.dropdownOptionContainer'),

                  getDisplay = function (jOption) {
                     var strSelectedDisplay = jOption.attr('selectedDisplay'),
                        strText = jOption.text(),
                        strDisplay = strSelectedDisplay || strText;

                     return strDisplay;
                  },

                  onOptionTriggered = function () {
                     var jOption = $(this),
                        strValue = jOption.attr('value'),
                        strDisplay = getDisplay(jOption);

                     if (jOption.length !== 0) {
                        // TODO: Make sure this works correctly
                        options.onOptionTriggered(strValue, strDisplay);
                     }
                  };

               if (options) {
                  if (options.dropdownClass) {
                     jList.addClass(options.dropdownClass);
                  }
               }

               jThis.data('c21list', {
                  target: jThis,
                  options: options,
                  aOptions: [],
                  aCheckboxes: [],
                  oCheckboxes: {},
                  jList: jList,
                  jOptionViewport: jOptionViewport,
                  jOptionContainer: jOptionContainer,
                  getDisplay: getDisplay
               });

               if (options.options) {
                  jThis.c21list("addOptionsList", options.options);
               } else {
                  var jFindOptions = (options.baseInput) ? options.baseInput : jThis;
                  jFindOptions.find('option').each(function (i, elOption) {
                     var jOption = $(elOption),
                        strValue = jOption.attr('value'),
                        strText = jOption.text(),
                        strSelectedDisplay = jOption.attr("selectedDisplay");

                     jThis.c21list("addOption", strText, strValue, strSelectedDisplay);
                  });
               }

               var jOptions = jList.find('.dropdownOption'),
                  jFirstOption = jOptions.eq(0);

               // Set the first option as selected
               jFirstOption.addClass('dropdownOptionSelected');

               jOptions.mouseover(function () {
                  var jOptions = jList.find('.dropdownOption'),
                     jOption = $(this);

                  jOptions.removeClass('dropdownOptionSelected');
                  jOption.addClass('dropdownOptionSelected');
               }).click(onOptionTriggered);

               var strChecked = options.checkedValues,
                  aStrChecked;

               if (strChecked) {
                  aStrChecked = strChecked.split(",");
                  $.each(aStrChecked, function (i, strValue) {
                     jThis.c21list("setChecked", strValue, true);
                  });
               }

               jThis.append(jList);
            }
         });
      },

      /**
       * Determine whether this element is hidden
       */
      hidden: function () {
         var data = $(this).data('c21list'),
            jList = data.jList;

         if (jList.attr('showing') === 'false') {
            return true;
         } else {
            return false;
         }
      },

      destroy: function () {
         return this.each(function () {
            var $this = $(this),
               data = $this.data('c21list');

            // Namespacing FTW
            $(window).unbind('.c21list');
            data.c21list.remove();
            $this.removeData('c21list');
         });
      }
   };

   $.fn.c21list = function (method) {
      if (methods[method]) {
         return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
      } else if (typeof method === 'object' || !method) {
         return methods.init.apply(this, arguments);
      } else {
         $.error('Method ' + method + ' does not exist on jQuery.c21list');
      }
   };
}(jQuery));
